import { required, shape } from '@totalsoft/pure-validations';

export const genericFilterParamValidator = shape({
  paramCode: required,
  paramName: required
});
